// REQ-39 (Faz-7) — SMTP e-posta ayarları API client (settings.read/manage).
//
// Uçlar `/api/v1/admin/settings/smtp`. Şifre write-only: GET'te `"***"` maskeli
// döner (alan boş bırakılır), PUT'ta `null`/boş gönderilince BE mevcut şifreyi
// korur. Test-mail ayarsızsa BE `SMTP_NOT_CONFIGURED` (422) döner.

import { http, unwrap, type ActionResponse } from './http';
import type { SmtpSettings, SmtpSettingsInput, SmtpTestResult } from '@features/smtp/types';

interface SmtpSettingsDtoWire {
  id?: string | null;
  host?: string | null;
  port?: number | null;
  username?: string | null;
  fromAddress?: string | null;
  fromName?: string | null;
  enableSsl?: boolean | null;
  enabled?: boolean | null;
  password?: string | null;
  hasPassword?: boolean | null;
  updatedAt?: string | null;
}

interface SmtpTestResultDtoWire {
  success?: boolean | null;
  error?: string | null;
}

const BASE = '/api/v1/admin/settings/smtp';

function mapSettings(d: SmtpSettingsDtoWire): SmtpSettings {
  return {
    host: d.host ?? '',
    port: d.port ?? 587,
    username: d.username ?? '',
    fromAddress: d.fromAddress ?? '',
    fromName: d.fromName ?? '',
    enableSsl: d.enableSsl ?? true,
    enabled: d.enabled ?? false,
    hasPassword: d.hasPassword ?? false,
    updatedAt: d.updatedAt ?? null,
  };
}

export const smtpApi = {
  async get(): Promise<SmtpSettings> {
    const res = await http.get<ActionResponse<SmtpSettingsDtoWire>>(BASE);
    return mapSettings(unwrap(res));
  },

  async update(input: SmtpSettingsInput): Promise<SmtpSettings> {
    const res = await http.put<ActionResponse<SmtpSettingsDtoWire>>(BASE, {
      host: input.host,
      port: input.port,
      username: input.username,
      // Boş bırakıldıysa null gönder — BE mevcut şifreyi korur.
      password: input.password,
      fromAddress: input.fromAddress,
      fromName: input.fromName,
      enableSsl: input.enableSsl,
      enabled: input.enabled,
    });
    return mapSettings(unwrap(res));
  },

  async test(recipient: string | null): Promise<SmtpTestResult> {
    const res = await http.post<ActionResponse<SmtpTestResultDtoWire>>(`${BASE}/test`, {
      recipient: recipient ?? null,
    });
    const dto = unwrap(res);
    return { success: dto.success ?? false, error: dto.error ?? null };
  },
};
